import { render } from "./EditMemo.vue?vue&type=template&id=cfae937e"
import script from "./EditMemo.vue?vue&type=script&lang=js"
export * from "./EditMemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__